"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = require("@vds/theme");
var _inputs = require("@vds-core/inputs");
var _typography = require("@vds/typography");
var _tooltips = require("@vds/tooltips");
var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");
var _excluded = ["size", "color", "surface", "name"];
var _templateObject;
var ErrorIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/_react["default"].createElement("title", null, "Error"), /*#__PURE__*/_react["default"].createElement("rect", {
  x: "11",
  y: "16.03",
  width: "2",
  height: "1.98"
}), /*#__PURE__*/_react["default"].createElement("polygon", {
  points: "12.33 14.04 11.66 14.04 11 10.94 11 7.02 12.99 7.02 12.99 10.94 12.33 14.04"
}), /*#__PURE__*/_react["default"].createElement("rect", {
  vectorEffect: "non-scaling-stroke",
  x: "4.34",
  y: "4.34",
  width: "15.31",
  height: "15.31",
  rx: "2",
  transform: "translate(-4.97 12) rotate(-45)"
}));
var IconSVGWrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "IconSVGWrapper",
  componentId: "sc-18s34mx-0"
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  height: ", ";\n  width: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  ", ";\n  &:active,\n  &:focus {\n    outline: none;\n  }\n  svg {\n    polygon,\n    rect {\n      stroke: none;\n      fill: ", ";\n    }\n    rect[vector-effect] {\n      stroke: ", ";\n      stroke-width: 1;\n      fill: none;\n    }\n  }\n"])), function (_ref) {
  var iconSize = _ref.iconSize;
  return (0, _javascriptStyleHelpers.calculateRem)(iconSize);
}, function (_ref2) {
  var iconSize = _ref2.iconSize;
  return (0, _javascriptStyleHelpers.calculateRem)(iconSize);
}, function (_ref3) {
  var iconSize = _ref3.iconSize;
  return (0, _javascriptStyleHelpers.calculateRem)(iconSize);
}, function (_ref4) {
  var iconSize = _ref4.iconSize;
  return (0, _javascriptStyleHelpers.calculateRem)(iconSize);
}, function (_ref5) {
  var tabIndex = _ref5.tabIndex;
  return tabIndex < 0 && "\n    outline: none;\n    pointer-events: none;\n  ";
}, function (_ref6) {
  var iconColor = _ref6.iconColor;
  return iconColor;
}, function (_ref7) {
  var iconColor = _ref7.iconColor;
  return iconColor;
});
var propTypes = {
  /**
   * Component will render in Inverted state.
   */
  inverted: _propTypes["default"].bool,
  /**
   * String, array or node containing the title of the TooltipDialog
   */
  tooltipTitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].node]),
  /**
   * String, array or node containing the body content of the TooltipDialog
   */
  tooltipContent: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].node])
};
var defaultProps = {
  inverted: false
};
var _getColor = function _getColor(disabled, surface) {
  if (surface !== "dark" && !disabled) {
    return _theme.colors.black;
  } else if (disabled) {
    return surface === "dark" ? _theme.colors.coolGray10 : _theme.colors.coolGray3;
  } else {
    return _theme.colors.white;
  }
};
var _calculateBackgroundColor = function _calculateBackgroundColor(error, surface) {
  return surface === "dark" ? _theme.colors.black : _theme.colors.white;
};
var _calculateHoverBottomBorderColor = function _calculateHoverBottomBorderColor(error, errorState, surface) {
  return error || errorState ? _theme.colors.error : surface === "dark" ? _theme.colors.white : _theme.colors.black;
};
var _overflowTextColor = function _overflowTextColor(surface) {
  return "transparent";
};
var _overflowBackgroundColor = function _overflowBackgroundColor(surface) {
  return surface === "dark" ? _theme.colors.coolGray6 : _theme.colors.coolGray3;
};
var _calculateHelperTextColor = function _calculateHelperTextColor(inverted, disabled) {
  if (disabled) {
    return inverted ? _theme.colors.coolGray10 : _theme.colors.coolGray3;
  } else {
    return _theme.colors.coolGray6;
  }
};
var _calculateBorderColor = function _calculateBorderColor(props) {
  var error = props.error,
    errorState = props.errorState,
    disabled = props.disabled,
    focused = props.focused,
    surface = props.surface,
    readOnly = props.readOnly;
  return readOnly && surface === "dark" ? _theme.colors.coolGray10 : readOnly ? _theme.colors.coolGray3 : focused && surface === "dark" ? _theme.colors.white : focused ? _theme.colors.black : (error || errorState) && !disabled ? _theme.colors.error : surface === "dark" ? _theme.colors.coolGray10 : _theme.colors.coolGray3;
};
var _calculateLabelColor = function _calculateLabelColor(disabled, surface) {
  var labelColor;
  if (disabled) {
    surface === "dark" ? labelColor = _theme.colors.coolGray10 : labelColor = _theme.colors.coolGray3;
  } else {
    surface === "dark" ? labelColor = _theme.colors.white : labelColor = _theme.colors.black;
  }
  return labelColor;
};
var _calculateOptionalLabelColor = function _calculateOptionalLabelColor(disabled, surface) {
  return disabled && surface !== "dark" ? _theme.colors.coolGray3 : disabled && surface === "dark" ? _theme.colors.coolGray10 : _theme.colors.coolGray6;
};

// Extract props passed from core's tooltip and re-apply surface to enable inverted state.
var _renderTooltip = function _renderTooltip(tooltipCoreProps) {
  return /*#__PURE__*/_react["default"].createElement(_tooltips.Tooltip, (0, _extends2["default"])({}, tooltipCoreProps, {
    inverted: tooltipCoreProps.surface === "dark"
  }));
};

// Use error.svg icon
var _renderIcon = function _renderIcon(iconProps) {
  var size = iconProps.size,
    color = iconProps.color,
    surface = iconProps.surface,
    name = iconProps.name,
    rest = (0, _objectWithoutProperties2["default"])(iconProps, _excluded);
  var iconSize;
  switch (size) {
    case "medium":
    default:
      iconSize = 20;
  }
  return /*#__PURE__*/_react["default"].createElement(IconSVGWrapper, (0, _extends2["default"])({
    iconSize: iconSize,
    iconColor: surface === "dark" ? _theme.colors.white : _theme.colors.black,
    "aria-label": "".concat(name, " icon")
  }, rest), ErrorIcon);
};
var TextArea = function TextArea(props) {
  return /*#__PURE__*/_react["default"].createElement(_inputs.TextArea, (0, _extends2["default"])({}, props, {
    surface: props.inverted ? "dark" : "light",
    transparentBackground: false // Brand3 only
    ,
    color: _theme.colors,
    Body: _typography.Body,
    Micro: _typography.Micro,
    Tooltip: _renderTooltip,
    Icon: _renderIcon,
    maxWidth: (0, _javascriptStyleHelpers.calculateRem)(596),
    minWidth: (0, _javascriptStyleHelpers.calculateRem)(182),
    borderRadius: "0px",
    getColor: _getColor,
    calculateBackgroundColor: _calculateBackgroundColor,
    calculateHelperTextColor: function calculateHelperTextColor() {
      return _calculateHelperTextColor(props.inverted, props.disabled);
    },
    calculateBorderColor: _calculateBorderColor,
    calculateHoverBottomBorderColor: _calculateHoverBottomBorderColor,
    heavyErrorBorder: true,
    overflowTextColor: _overflowTextColor,
    overflowBackgroundColor: _overflowBackgroundColor,
    calculateElementColor: _calculateLabelColor,
    calculateOptionalLabelColor: _calculateOptionalLabelColor,
    highlightZIndex: 0
  }));
};
TextArea.propTypes = propTypes;
TextArea.defaultProps = defaultProps;
var _default = exports["default"] = TextArea;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/inputs/dist/cjs/components/TextArea/TextArea.js
// module id = 1459
// module chunks = 0